// 'use client';
// import { useRouter } from 'next/navigation';

// const LanguageSwitcher = () => {
//   const changeLanguage = (lang: string) => {
//     document.cookie = `locale=${lang}; path=/; max-age=${31536000}`;
//     window.location.reload(); // ✅ Refresh page to apply immediately
//   };

//   const currentLang =
//     document.cookie.replace(
//       /(?:(?:^|.*;\s*)locale\s*\=\s*([^;]*).*$)|^.*$/,
//       '$1'
//     ) || 'en';

//   return (
//     <select
//       onChange={(e) => changeLanguage(e.target.value)}
//       defaultValue={currentLang}
//       className="px-3 py-1 rounded-full border border-gray-300 bg-white text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-400"
//     >
//       <option value="en">English</option>
//       <option value="hi">हिन्दी</option>
//       <option value="mr">मराठी</option>
//       <option value="kn">ಕನ್ನಡ</option>
//       <option value="gu">ગુજરાતી</option>
//     </select>
//   );
// };

// export default LanguageSwitcher;


'use client';

import { useEffect, useState } from "react";

const LanguageSwitcher = () => {
  const [currentLang, setCurrentLang] = useState("en");

  // Read cookie only in browser
  useEffect(() => {
    const cookie =
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("locale="));

    const lang = cookie?.split("=")[1] || "en";
    setCurrentLang(lang);
  }, []);

  const changeLanguage = (lang: string) => {
    document.cookie = `locale=${lang}; path=/; max-age=${31536000}`;
    window.location.reload();
  };

  return (
    <select
      onChange={(e) => changeLanguage(e.target.value)}
      value={currentLang}
      className="block w-full border-2 border-black text-black hover:border-primary hover:text-primary hover:bg-warm-50 font-bold px-2 py-2 sm:px-4 sm:py-2 rounded-br-2xl rounded-tl-2xl text-xs sm:text-sm leading-[1.9] uppercase bg-transparent text-center xl:text-left"
    >
      <option value="en">English</option>
      <option value="mr">मराठी</option>
      <option value="hi">हिन्दी</option>
      {/* <option value="kn">ಕನ್ನಡ</option>
      <option value="gu">ગુજરાતી</option>
      <option value="bn">বাংলা</option>
      <option value="ta">தமிழ்</option>
      <option value="te">తెలుగు</option>
      <option value="pa">ਪੰਜਾਬੀ</option>
      <option value="ml">മലയാളം</option> */}



    </select>
  );
};

export default LanguageSwitcher;
